__turbopack_context__.v({
  "box": "_8hlawq_box",
  "box-wide": "_8hlawq_box-wide",
  "fieldset": "_8hlawq_fieldset",
  "placeholder": "_8hlawq_placeholder",
  "row": "_8hlawq_row",
  "row-columns-1fr": "_8hlawq_row-columns-1fr",
  "row-columns-1fr-1fr": "_8hlawq_row-columns-1fr-1fr",
  "row-columns-1fr-2fr": "_8hlawq_row-columns-1fr-2fr",
  "row-columns-2fr-1fr": "_8hlawq_row-columns-2fr-1fr",
});
